import PageCourseTopic from './PageCourseTopic';

export default PageCourseTopic;
